import Icon from '@/components/icons/Icon';
import { classnames } from '@/helpers';

interface BreadcrumbsProps {
  className?: string;
  items: { title: string; url: string }[];
}

const Breadcrumbs = ({ items, className = '' }: BreadcrumbsProps) => {
  return (
    <div className={className}>
      <ol className="gap-2xs flex list-none">
        {items.map((item, index) => {
          const isCurrentLink = items.length === index + 1;
          return (
            <li key={`${index + 1}`} className={`gap-2xs flex items-center ${isCurrentLink ? 'min-w-0' : 'shrink-0'}`}>
              <div
                key={`item-${index + 1}`}
                className={`before:text-black-600 text-l ${isCurrentLink ? 'min-w-0 truncate' : 'inline-block'}`}>
                {isCurrentLink ? (
                  <span className="text-fg_primary">{item.title}</span>
                ) : (
                  <a className={classnames('text-fg_link_bold cursor-pointer underline')} href={item.url}>
                    <span>{item.title}</span>
                  </a>
                )}
              </div>
              {!isCurrentLink && (
                <Icon
                  style={{ width: 16, height: 16 }}
                  key={`separator-${index + 1}`}
                  variant="arrow-right"
                  size="xs"
                  color="black-600"
                />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default Breadcrumbs;
